<div class="overview-panel" [ngClass]="{'overview-hidden': isOverviewActive}">
    <div class="overview-inner">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="fw-4">{{SCHEMA_OVERVIEW}}</h4>
            <button mat-button (click)="close()">{{CLOSE}}</button>
        </div>
        <div class="d-flex flex-row mb-2">
            <mat-form-field appearance="fill" class="flex-grow-1 me-2 mt-1">
                <input matInput [formControl]="searchBox" placeholder="Name" (keyup.enter)="getSchemas()">
            </mat-form-field>
            <button mat-fab (click)="getSchemas()">
                @if(!isLoading){
                    <mat-icon>search</mat-icon>
                }@else{
                    <mat-progress-spinner class="small-spinner bright-spinner" mode="indeterminate"></mat-progress-spinner>
                }
            </button>
        </div>
        @if (!isLoading) {
            @for (ds of ds_models; track $index) {
                <div class="mb-5 w-100">
                    <h5>{{ds.string_connection}}</h5>
                    <div class="row w-100">
                        @for (model of ds.models; track $index) {
                            <div class="col-6 p-2">
                                <mat-card appearance="outlined" >
                                    <mat-card-header class="mb-2">
                                        <mat-card-title>{{model.name}}</mat-card-title>
                                        <mat-card-subtitle class="text-color-primary">{{model.hierarchy}}</mat-card-subtitle>
                                    </mat-card-header>
                                    <mat-card-actions align="end">
                                        <mat-icon [matMenuTriggerFor]="menu" class="cursor-pointer" (click)="setSelectedSchema(model, ds)">more_vert</mat-icon>
                                    </mat-card-actions>
                                </mat-card>
                            </div> 
                        }
                    </div>
                    <hr>
                </div>
            }
        }@else {
            <div class="h-100 d-flex justify-content-center align-items-center loading">
                <mat-progress-spinner class="bright-spinner" mode="indeterminate"> </mat-progress-spinner>
            </div>
        }
    </div>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="onShowThisTab()" [disabled]="shouldImportInThisTab()">Show in this Tab</button>
  <button mat-menu-item (click)="onShowinNewTab()" >Show in a new Tab</button>
</mat-menu>